module.exports = __webpack_public_path__ + "static/media/flapx2_pockets.228c7330.svg";